import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getPrivacyPolicyLink } from '../utils';

export const PrivacyPolicyCandidate = () => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    return (
        <Trans
            t={t}
            i18nKey="apply_form.privacy_policy_candidate"
            values={{ privacy_policy: t('apply_form.data_processing_notice_candidate') }}
            components={[
                <a target="blank" rel="noreferrer" href={getPrivacyPolicyLink()}>{t('apply_form.data_processing_notice_candidate')}</a>,
            ]}
        />
    );
};
